import { useStore } from 'effector-react'
import * as React from 'react'

import { $domains, domainsListMounted, getDomains } from './model'
import { DomainRequest } from './types'

export const useDomainsList = () => {
  React.useEffect(() => {
    domainsListMounted({
      limit: 10,
      page: 1,
      orderBy: 'domain',
      orderDirection: '-',
      searchText: '',
      searchedColumn: '',
    })
  }, [])
  const onChangeDomainsList = ({
    limit,
    page,
    orderBy,
    orderDirection,
    searchText,
    searchedColumn,
  }: DomainRequest) => {
    domainsListMounted({
      limit,
      page,
      orderBy,
      orderDirection,
      searchText,
      searchedColumn,
    })
  }
  const domains = useStore($domains)
  const loading = useStore(getDomains.pending)
  return { domains, loading, onChangeDomainsList }
}
